export default __webpack_public_path__ + "static/media/qr-icon5.19596c18.png";